var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"act-header flex-row flex-between"},[_c('div',{staticClass:"flex-row flex-between flex-adapt block-mobile"},[_c('h1',[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }